import { portraitCanvas } from "../art/cast";
import { type Ctx, INK, R } from "../art/pixel";

/**
 * The clerk portrait used as the favicon, the title-screen emblem and the
 * blinking tab icon. Same 16×16 art as public/favicon.svg.
 */

const NAVY = "#2c40a3";

/** Rounded 16×16 navy tile (2px corners cut, matching the SVG favicon). */
function tile(c: Ctx): void {
  R(c, NAVY, 2, 0, 12, 16);
  R(c, NAVY, 0, 2, 16, 12);
  R(c, NAVY, 1, 1, 14, 14);
}

/** Draw the 16×16 emblem at the origin of `c` (scale with setTransform). */
export function drawEmblem(c: Ctx, eyesClosed: boolean): void {
  tile(c);
  c.drawImage(portraitCanvas("clerk"), 0, 0);
  if (eyesClosed) {
    // Eyes sit at (5,7) and (10,7); a closed eye is a 2px line across the same row.
    R(c, INK, 4, 7, 2, 1);
    R(c, INK, 10, 7, 2, 1);
  }
}

/** Render the emblem to a PNG data URL at `px` pixels square. */
export function emblemDataUrl(eyesClosed: boolean, px = 32): string {
  const cv = document.createElement("canvas");
  cv.width = px;
  cv.height = px;
  const c = cv.getContext("2d");
  if (!c) return "";
  c.imageSmoothingEnabled = false;
  c.setTransform(px / 16, 0, 0, px / 16, 0, 0);
  drawEmblem(c, eyesClosed);
  return cv.toDataURL("image/png");
}

/** When to blink: a short blink every few seconds, sometimes a double blink. */
export function isBlinking(now: number): boolean {
  const cycle = 4200;
  const t = now % cycle;
  const double = Math.floor(now / cycle) % 3 === 2;
  return t < 140 || (double && t > 260 && t < 380);
}
